<template><section><h1>dataset</h1>
<p>qcharts 内置了 <code v-pre>数据集（dataset）</code> 用于单独管理数据，从而使得多个组件可以复用一份数据以及数据驱动组件变化，同时还可以更加自由地指定数据到视觉的映射。</p>
<blockquote>
<p><code v-pre>dataset</code> 属于内置组件，无需显式地声明调用。</p>
</blockquote>
<h2>使用</h2>
<p><code v-pre>dataset</code> 需要设置数据源，同时需要指定 <code v-pre>row</code>、<code v-pre>value</code> 等特殊维度属性便可完成数据处理。</p>
<block-demo tip="hideEditor" source="const data = [
  { product: &#39;05-08&#39;, year: &#39;图例一&#39;, sales: 42 },
  { product: &#39;05-08&#39;, year: &#39;图例二&#39;, sales: 78.2 },
  { product: &#39;05-08&#39;, year: &#39;图例三&#39;, sales: 62 },
  { product: &#39;05-09&#39;, year: &#39;图例一&#39;, sales: 80 },
  { product: &#39;05-09&#39;, year: &#39;图例二&#39;, sales: 108 },
  { product: &#39;05-09&#39;, year: &#39;图例三&#39;, sales: 64 },
  { product: &#39;05-10&#39;, year: &#39;图例一&#39;, sales: 36 },
  { product: &#39;05-10&#39;, year: &#39;图例二&#39;, sales: 91 },
  { product: &#39;05-10&#39;, year: &#39;图例三&#39;, sales: 56 }
]
const { Chart, Bar, Axis, Legend } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;year&#39;,
  value: &#39;sales&#39;,
  text: &#39;product&#39;
})

const bar = new Bar({})
const legend = new Legend({ align: [&#39;center&#39;, &#39;top&#39;] })
const xAxis = new Axis()
const yAxis = new Axis({ orient: &#39;left&#39; })

chart.append([bar, legend, xAxis, yAxis])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-08'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">42</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-08'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">78.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-08'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">62</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-09'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">80</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-09'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">108</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-09'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">64</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-10'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">36</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-10'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">91</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'05-10'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">56</span> }
]
<span class="hljs-keyword">const</span> { Chart, Bar, Axis, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'year'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'sales'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'product'</span>
})

<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({})
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'top'</span>] })
<span class="hljs-keyword">const</span> xAxis = <span class="hljs-keyword">new</span> Axis()
<span class="hljs-keyword">const</span> yAxis = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

chart.append([bar, legend, xAxis, yAxis])
</code></pre>
</block-demo><h3>datset 的维度</h3>
<p><code v-pre>dataset</code> 在设置数据源的同时也需要指定一些维度，才能完成数据处理。</p>
<ul>
<li><strong>row</strong>: <code v-pre>行数据</code> 划分依据字段，<code v-pre>dataset</code> 会按照 <code v-pre>row</code> 字段的值对数据进行数据分组。例如上方的柱形图中指定 <code v-pre>row</code> 为 <code v-pre>year</code>，则 <code v-pre>dataset</code> 会将 <code v-pre>year</code> 相同的数据聚为一组。</li>
<li><strong>value</strong>: <code v-pre>dataset</code> 处理数据数值的依据字段。不设置将导致 <code v-pre>dataset</code> 无法处理数据中的数值，从而导致后续图表无法渲染，故必须设置。</li>
<li><strong>text</strong>: 该字段用于标记数据的文本字段。默认情况下为 <code v-pre>row</code> 所指定的字段。</li>
<li><strong>layoutScale</strong>: 该字段用于对数据进行缩放处理。默认无缩放，可以指定<code v-pre>sqrt</code>、<code v-pre>sqrt+n</code>（开 n 次更号）、<code v-pre>pow</code>、<code v-pre>pow+n</code>（n 次方）、<code v-pre>log</code>、<code v-pre>log2</code>、<code v-pre>log10</code>等方式。
<br></li>
</ul>
<p>由于 <code v-pre>qcharts</code> 中的图表以及相关插件默认都是按照 <code v-pre>行数据（layoutBy='row'）</code> 进行渲染</p>
<h3>按行（或按列）映射</h3>
<p><code v-pre>dataset</code> 可以指定 <code v-pre>row</code> 分组数据，所以图表的渲染便有了 2 种模式取值：</p>
<ul>
<li><strong>row</strong>: 默认值，取 dataset 的 行数据。</li>
<li><strong>col</strong>: 取 dataset 的 列数据。</li>
</ul>
<block-demo tip="" source="const data = [
  { product: &#39;茶叶&#39;, year: &#39;2016&#39;, sales: 81.2 },
  { product: &#39;茶叶&#39;, year: &#39;2017&#39;, sales: 121.2 },
  { product: &#39;茶叶&#39;, year: &#39;2018&#39;, sales: 41.2 },
  { product: &#39;牛奶&#39;, year: &#39;2016&#39;, sales: 85.2 },
  { product: &#39;牛奶&#39;, year: &#39;2017&#39;, sales: 79.6 },
  { product: &#39;牛奶&#39;, year: &#39;2018&#39;, sales: 81.2 },
  { product: &#39;咖啡&#39;, year: &#39;2016&#39;, sales: 65.2 },
  { product: &#39;咖啡&#39;, year: &#39;2017&#39;, sales: 59.6 },
  { product: &#39;咖啡&#39;, year: &#39;2018&#39;, sales: 61.2 },
  { product: &#39;椰汁&#39;, year: &#39;2016&#39;, sales: 35.2 },
  { product: &#39;椰汁&#39;, year: &#39;2017&#39;, sales: 79.6 },
  { product: &#39;椰汁&#39;, year: &#39;2018&#39;, sales: 21.2 }
]

const { Chart, Bar, Line, Axis, Legend } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;year&#39;,
  col: &#39;product&#39;,
  value: &#39;sales&#39;,
  text: &#39;product&#39;
})
const clientRect = {
  top: 20,
  left: 30,
  right: 30,
  bottom: 40
}
const bar = new Bar({ clientRect })
const legend = new Legend({ align: [&#39;center&#39;, &#39;default&#39;] })
const xAxis = new Axis({ clientRect })
const yAxis = new Axis({ clientRect, orient: &#39;left&#39; })
chart.append([bar, legend, xAxis, yAxis])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'茶叶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2016'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'茶叶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2017'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">121.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'茶叶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2018'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">41.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'牛奶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2016'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">85.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'牛奶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2017'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'牛奶'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2018'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'咖啡'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2016'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">65.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'咖啡'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2017'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">59.6</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'咖啡'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2018'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">61.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'椰汁'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2016'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">35.2</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'椰汁'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2017'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span> },
  { <span class="hljs-attr">product</span>: <span class="hljs-string">'椰汁'</span>, <span class="hljs-attr">year</span>: <span class="hljs-string">'2018'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">21.2</span> }
]

<span class="hljs-keyword">const</span> { Chart, Bar, Line, Axis, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'year'</span>,
  <span class="hljs-attr">col</span>: <span class="hljs-string">'product'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'sales'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'product'</span>
})
<span class="hljs-keyword">const</span> clientRect = {
  <span class="hljs-attr">top</span>: <span class="hljs-number">20</span>,
  <span class="hljs-attr">left</span>: <span class="hljs-number">30</span>,
  <span class="hljs-attr">right</span>: <span class="hljs-number">30</span>,
  <span class="hljs-attr">bottom</span>: <span class="hljs-number">40</span>
}
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({ clientRect })
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'default'</span>] })
<span class="hljs-keyword">const</span> xAxis = <span class="hljs-keyword">new</span> Axis({ clientRect })
<span class="hljs-keyword">const</span> yAxis = <span class="hljs-keyword">new</span> Axis({ clientRect, <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })
chart.append([bar, legend, xAxis, yAxis])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>